module.exports = {
  cant_deactivate: '<span>Diese E-Mail kannst du nicht deaktivieren. Wende dich bei Fragen an deinen <span class="underline">Administrator</span>.</span>',
  receive: 'aktiv',
  browser_notifications_enabled: 'aktiviert',
  browser_notifications_request_again: 'Benachrichtigungen aktivieren',
  browser_notifications_tutorial_link: 'Tutorial anzeigen',
  browser_notifications_tutorial: {
    firefox: [
      'Klicke auf die Menüschaltfläche (drei horizontale Linien) und wähle Einstellungen.',
      'Gehe zu Datenschutz & Sicherheit.',
      'Unter Berechtigungen findest du Benachrichtigungen – klicke auf Einstellungen.',
      'Entferne den Haken bei „Neue Anfragen zum Zulassen von Benachrichtigungen blockieren“, damit Anfragen angezeigt werden.',
    ],
    edge: [
      'Klicke auf das Schloss-Symbol in der Adressleiste, wähle Berechtigungen für diese Website und erlaube Benachrichtigungen.',
      'Falls das nicht klappt: Klicke oben rechts auf das Drei-Punkte-Menü und wähle Einstellungen.',
      'Navigiere zu Cookies und Websiteberechtigungen > Benachrichtigungen.',
      'Damit Anfragen erlaubt werden, lasse „Vor dem Senden nachfragen“ aktiviert.',
      'Um einzelne Websites zu verwalten, verwende die Schaltfläche „Hinzufügen“ unter „Zulassen“ und trage die URL %{url} ein.',
    ],
    chrome: [
      'Klicke auf das Schloss-Symbol in der Adressleiste, wähle Website-Einstellungen und erlaube Benachrichtigungen.',
      'Falls das nicht klappt: Klicke oben rechts auf das Drei-Punkte-Menü und wähle Einstellungen.',
      'Navigiere zu Datenschutz und Sicherheit > Website-Einstellungen > Benachrichtigungen.',
      'Stelle sicher, dass „Websites dürfen um das Senden von Benachrichtigungen bitten“ aktiviert ist.',
      'Um keelearning direkt frei zu schalten, verwende die Schaltfläche „Hinzufügen“ unter „Zulassen“ und trage %{url} ein.',
    ],
    safari: [
      'Klicke in der oberen Menüleiste auf Safari und wähle Einstellungen.',
      'Wechsle zum Tab Websites und wähle Benachrichtigungen.',
      'Erlaube oder verweigere Benachrichtigungen für jede gelistete Website. Stelle sicher, dass „Websites dürfen um Berechtigungen bitten“ aktiviert ist.',
    ],
  },
  beekeeper_notifications: 'Beekeeper',
  notifications: {
    NewChatMessages: 'Chat: Neue Nachricht erhalten',
    SubscriptionComment: 'Kommentar: Benachrichtigen bei neuen Antworten',
    CommentReply: 'Kommentar: Benachrichtigen bei neuen Antworten',
    CommentDeletedForAuthor: 'Kommentar: Dein Kommentar wurde entfernt',
    CommentDeletedForReporter: 'Kommentar: Gemeldeter Kommentar wurde entfernt',
    CommentNotDeleted: 'Kommentar: Gemeldeter Kommentar wurde nicht entfernt',
    NewCommunityPost: 'Community: Neuer Beitrag',
    CommunityPostKnowledgeableUserRequested: 'Community-Beitrag: Anfragen zu deiner Expertise',
    CommunityPostRandomUserRequested: 'Community-Beitrag: Anfragen zu deiner Meinung',
    CompetitionReminder: 'Gewinnspiel: Erinnerung',
    NewCourseNotification: 'Kurse: Neuer Kurs',
    PassedCourse: 'Kurse: Kurs bestanden',
    CoursesWeeklyReminder: 'Kurse: Wöchentliche Kursübersicht',
    CourseReminder: 'Kurse: Erinnerung an laufenden Kurs',
    AppointmentParticipationConfirmation: 'Termine: Anmeldebestätigung',
    NewAppointment: 'Termine: Neuer Termin',
    AppointmentStartDateWasUpdated: 'Termine: Terminänderung',
    LearningMaterialsPublished: 'Mediathek: Neue Inhalte',
    AppointmentReminder: 'Termine: Terminerinnerung',
    GameAbort: 'Quiz-Challenge: Spielabbruch',
    QuizTeamAdd: 'Quiz-Challenge: Du wurdest zu einem Quiz-Team hinzugefügt',
    GameInvitation: 'Quiz-Challenge: Duell-Aufforderung durch anderen Spieler',
    GameReminder: 'Quiz-Challenge: Du bist am Zug',
    GameWonInfo: 'Quiz-Challenge: Spiel gewonnen',
    GameLostInfo: 'Quiz-Challenge: Spiel verloren',
    GameDrawInfo: 'Quiz-Challenge: Spiel unentschieden',
    NewsPublishedInfo: 'News: Neue Nachrichten',
    TestReminder: 'Test: Erinnerung an Test-Teilnahme',
    TestPassed: 'Test: Test bestanden',
    CompetitionInvitation: 'Gewinnspiel: Neues Gewinnspiel',
    CompetitionResult: 'Gewinnspiel: Spielergebnis',
    ExpirationReminder: 'User: Dein Account wird bald gelöscht',
    AppReminder: 'User: Wir vermissen dich',
    WebinarReminder: 'Webinar: Meeting startet gleich',
  },
  browser_notifications_tutorial_title: 'So aktivierst du Browser-Benachrichtigungen',
  browser_notifications_disabled: 'deaktiviert',
  settings_disabled: 'Der Admin hat diesen Bereich leider nicht freigegeben. <br /> Kontaktiere deinen Admin bei Fragen unter %{email}',
  emails: 'E-Mail',
  push_notifications: 'Push',
  dont_receive: 'inaktiv',
  browser_notifications_unsupported: 'Von diesem Browser nicht unterstützt',
  setting_beekeeper_notifications: 'Beekeeper-Benachrichtigungen',
  browser_notifications: 'Browser-Benachrichtigungen für Chat',
  setting_emails: 'E-Mail-Benachrichtigungen',
  setting_push_notifications: 'Push-Notifications',
  browser_notifications_denied_hint: 'Berechtigung verweigert. Bitte aktiviere Benachrichtigungen in den Browser-Einstellungen.',
  save_settings_failed: 'Das Speichern der E-Mail Einstellungen ist fehlgeschlagen.',
  save: 'Speichern',
  description: 'Stelle ein, für welche Aktivitäten du E-Mail-Benachrichtigungen erhalten möchtest.',
}
